import { useCallback, useState } from 'react';
import {
  useCreateFCACredentials,
  useDeleteFCACredentials,
  useGetFCACredentials,
  useUpdateFCACredentials
} from '../../../services/report.service';
import toast from 'react-hot-toast';
import { extractApiError } from '../../../utils';

export const useFCA = ({ workflowId, enabled = true }) => {
  const createFCA = useCreateFCACredentials();
  const updateFCA = useUpdateFCACredentials();
  const deleteFCA = useDeleteFCACredentials();

  const [isOpenFCACredentials, setIsOpenFCACredentials] = useState(false);

  const {
    data: fcaCredentials,
    refetch: refetchFCA,
    error
  } = useGetFCACredentials({
    workflowId,
    queryParams: {
      enabled: enabled && !!workflowId
    }
  });

  const hasErrorOnFCA = !!error?.data;

  const onDeleteFCA = () => {
    deleteFCA.mutate(workflowId, {
      onSuccess: () => {
        toast.success('Successfully deleted!');
        setIsOpenFCACredentials(false);
        refetchFCA();
      },
      onError: err => {
        toast.error(extractApiError(err, 'Unable to delete FCA credentials.'));
      }
    });
  };

  const onCreateFCA = useCallback(
    (username, password) => {
      if (!!fcaCredentials && !hasErrorOnFCA)
        updateFCA.mutate(
          {
            workflowId,
            data: {
              username,
              password
            }
          },
          {
            onSuccess: () => {
              toast.success('Successfully updated!');
              setIsOpenFCACredentials(false);
              refetchFCA();
            },
            onError: err => {
              toast.error(extractApiError(err, 'Unable to update FCA credentials.'));
            }
          }
        );
      else
        createFCA.mutate(
          {
            workflowId,
            data: {
              username,
              password
            }
          },
          {
            onSuccess: () => {
              toast.success('Successfully saved');
              setIsOpenFCACredentials(false);
              refetchFCA();
            },
            onError: err => {
              toast.error(extractApiError(err, 'Unable to create FCA credentials.'));
            }
          }
        );
    },
    [fcaCredentials, workflowId, hasErrorOnFCA]
  );

  return {
    isOpenFCACredentials,
    setIsOpenFCACredentials,
    onCreateFCA,
    onDeleteFCA,
    fcaCredentials,
    hasErrorOnFCA,
    deletingFCA: deleteFCA.isLoading,
    creatingFCA: createFCA.isLoading,
    updatingFCA: updateFCA.isLoading
  };
};
